export const MENU_PROSES = "MENU_PROSES";
export const DETAIL_PROSES = "DETAIL_PROSES";